/**
 * Pinch-to-zoom + pan for the .map-modal image.
 *
 * Applies transform: translate(x,y) scale(s) directly to the <img> so zoom
 * and pan stay contained inside the .map-modal-frame (overflow: hidden).
 */

const MIN_SCALE  = 1;
const MAX_SCALE  = 4;
const SNAP_BELOW = 1.05;

function dist( t0, t1 ) {
	return Math.hypot( t1.clientX - t0.clientX, t1.clientY - t0.clientY );
}

function midpoint( t0, t1 ) {
	return {
		x: ( t0.clientX + t1.clientX ) / 2,
		y: ( t0.clientY + t1.clientY ) / 2,
	};
}

function initPinchZoom( img ) {
	let scale      = 1;
	let tx         = 0;
	let ty         = 0;

	// Pinch state
	let startDist  = null;
	let startScale = 1;
	let startMid   = null;
	let startTx    = 0;
	let startTy    = 0;

	// Pan state
	let panActive  = false;
	let panStartX  = 0;
	let panStartY  = 0;
	let panStartTx = 0;
	let panStartTy = 0;

	function clampTranslate( s, x, y ) {
		// How far the image can travel before its edge reaches the frame edge.
		const maxX = img.offsetWidth  * ( s - 1 ) / 2;
		const maxY = img.offsetHeight * ( s - 1 ) / 2;
		return {
			x: Math.min( maxX, Math.max( -maxX, x ) ),
			y: Math.min( maxY, Math.max( -maxY, y ) ),
		};
	}

	function applyTransform( s, x, y ) {
		const clamped      = clampTranslate( s, x, y );
		scale              = s;
		tx                 = clamped.x;
		ty                 = clamped.y;
		img.style.transform      = `translate(${ tx }px, ${ ty }px) scale(${ scale })`;
		img.style.transformOrigin = 'center center';
		img.style.touchAction    = 1 < scale ? 'none' : 'pinch-zoom';
	}

	img.addEventListener( 'touchstart', e => {
		if ( 2 === e.touches.length ) {
			// Pinch start — also cancels any active pan.
			e.preventDefault();
			panActive  = false;
			startDist  = dist( e.touches[0], e.touches[1] );
			startScale = scale;
			startMid   = midpoint( e.touches[0], e.touches[1] );
			startTx    = tx;
			startTy    = ty;
		} else if ( 1 === e.touches.length && 1 < scale ) {
			// Single-finger pan — only when zoomed in.
			e.preventDefault();
			panActive  = true;
			panStartX  = e.touches[0].clientX;
			panStartY  = e.touches[0].clientY;
			panStartTx = tx;
			panStartTy = ty;
		}
	}, { passive: false });

	img.addEventListener( 'touchmove', e => {
		if ( 2 === e.touches.length && null !== startDist ) {
			// Pinch move.
			e.preventDefault();
			const d        = dist( e.touches[0], e.touches[1] );
			const newScale = Math.min( MAX_SCALE, Math.max( MIN_SCALE, startScale * ( d / startDist ) ) );
			const mid      = midpoint( e.touches[0], e.touches[1] );
			applyTransform(
				newScale,
				startTx + ( mid.x - startMid.x ),
				startTy + ( mid.y - startMid.y ),
			);
		} else if ( 1 === e.touches.length && panActive ) {
			// Pan move.
			e.preventDefault();
			applyTransform(
				scale,
				panStartTx + ( e.touches[0].clientX - panStartX ),
				panStartTy + ( e.touches[0].clientY - panStartY ),
			);
		}
	}, { passive: false });

	img.addEventListener( 'touchend', () => {
		startDist = null;
		panActive = false;
		if ( scale < SNAP_BELOW ) applyTransform( MIN_SCALE, 0, 0 );
	});
}

export function initMapPinchZoom() {
	document.querySelectorAll( '.map-modal' ).forEach( modal => {
		const img = modal.querySelector( 'img' );
		if ( img ) initPinchZoom( img );

		modal.addEventListener( 'close', () => {
			const i = modal.querySelector( 'img' );
			if ( i ) {
				i.style.transform   = '';
				i.style.touchAction = 'pinch-zoom';
			}
		});
	});
}
